import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';

interface SignOutPermissionTooltipSignature {
  Element: HTMLSpanElement;
}

const TOOLTIP_TEXT = 'Only admins/users with permission can sign out visitors at this location.';

export default class SignOutPermissionTooltip extends Component<SignOutPermissionTooltipSignature> {
  text = TOOLTIP_TEXT;
  descriptionId = `sign-out-permission-tip-${guidFor(this)}`;

  <template>
    <span
      class="relative inline-flex items-center align-middle ml-1"
      tabindex="0"
      role="img"
      aria-label={{this.text}}
      aria-describedby={{this.descriptionId}}
      data-test-sign-out-permission-tooltip
      ...attributes
    >
      {{svgJar "tooltip-info" class="w-4 h-4" aria-hidden="true"}}
      <span id={{this.descriptionId}} class="sr-only">{{this.text}}</span>
      <EmberTooltip @side="bottom" @delay={{200}} @popperContainer="body" @tooltipClass="!max-w-96">
        {{this.text}}
      </EmberTooltip>
    </span>
  </template>
}
